module.exports = __webpack_public_path__ + "Roboto-Regular.f4ba5d0b3d4b31187127.svg";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Regular.svg
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Regular.svg
// module chunks = styles